import { render, staticRenderFns } from "./People2.vue?vue&type=template&id=7b1d3b64&scoped=true&"
import script from "./People2.vue?vue&type=script&lang=js&"
export * from "./People2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b1d3b64",
  null
  
)

export default component.exports